const classAnnouncement = {
  path: 'classAnnouncement/:myClassId',
  component: resolve => require(['../../../../components/pages/student_user/classAnnouncement'], resolve),
  props: true
}
export default classAnnouncement
